import { FC } from "react";
import errorSvg from "../../images/icons/error.svg";
import styles from "./ErrorMessage.module.scss";
interface Props {
  message: string;
}
const ErrorMessage: FC<Props> = ({ message }) => {
  return (
    <div className={styles.errorText}>
      <img src={errorSvg} alt="Error icon" /> {message}
    </div>
  );
};

export default ErrorMessage;
